import React from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { webProjects } from '../constants/data.js';
import { Container } from '../styles/components.js';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

// Styled components
const DetailContainer = styled.div`
  padding: ${({ theme }) => theme.spacing.xxl} 0;
  background-color: ${({ color }) => color}33;
  border-radius: ${({ theme }) => theme.borderRadius.medium};
`;

const ProjectTitle = styled.h1`
  color: ${({ theme }) => theme.colors.textDark};
  margin-bottom: ${({ theme }) => theme.spacing.lg};
  text-align: center;
`;

const SubHeading = styled.h3`
  color: ${({ theme }) => theme.colors.textDark};
  margin-top: ${({ theme }) => theme.spacing.lg};
`;

// ProjectDescription was here but unused

const CarouselImage = styled.img`
  width: 100%;
  max-height: 400px;
  object-fit: cover;
  border-radius: ${({ theme }) => theme.borderRadius.medium};
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: ${({ theme }) => theme.spacing.lg};

  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

const ActionButton = styled.a`
  padding: 12px 24px;
  background-color: ${({ theme }) => theme.colors.primary};
  color: #fff;
  border-radius: ${({ theme }) => theme.borderRadius.small};
  text-decoration: none;
  font-weight: bold;
  transition: background-color 0.3s ease;
  text-align: center;

  &:hover {
    background-color: ${({ theme }) => theme.colors.primaryDark};
  }
`;

const TagsContainer = styled.div`
  margin-top: ${({ theme }) => theme.spacing.lg};
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
`;

const Tag = styled.span`
  background-color: ${({ theme }) => theme.colors.backgroundLight};
  color: ${({ theme }) => theme.colors.textDark};
  padding: 6px 12px;
  border-radius: ${({ theme }) => theme.borderRadius.small};
  font-size: ${({ theme }) => theme.typography.body.small};
`;

// Component
const WebProjectDetails = () => {
  const { id } = useParams();
  const project = webProjects.find(p => p.id === parseInt(id));

  if (!project) return <div>Project not found</div>;

  return (
    <DetailContainer color={project.color}>
      <Container>
        <ProjectTitle>{project.projectsName}</ProjectTitle>

        {project.coverImage && (
          <Carousel
            showThumbs={false}
            infiniteLoop
            autoPlay
            interval={3000}
            showStatus={false}
          >
            {project.coverImage.map((img, idx) => (
              <div key={idx}>
                <CarouselImage src={img} alt={`Slide ${idx + 1}`} />
              </div>
            ))}
          </Carousel>
        )}

        <ButtonGroup>
          {project.url && (
            <ActionButton href={`https://${project.url}`} target="_blank" rel="noopener noreferrer">
              View Demo
            </ActionButton>
          )}
          {project.githubCode && (
            <ActionButton href={project.githubCode} target="_blank" rel="noopener noreferrer">
              View Source Code
            </ActionButton>
          )}
        </ButtonGroup>

        {project.tags && (
          <>
            <SubHeading>Technologies Used:</SubHeading>
            <TagsContainer>
              {project.tags.map((tag, index) => (
                <Tag key={index}>{tag}</Tag>
              ))}
            </TagsContainer>
          </>
        )}
      </Container>
    </DetailContainer>
  );
};

export default WebProjectDetails;
